import { Injectable } from '@angular/core';
import { StraightStairService } from './straight-stairs.service';
import { StairLandingLeftService } from './stair-landing-left.service';
import { StairLandingRightService } from './stair-landing-right.service';
import { StairLandingStraightService } from './stair-landing-straight.service';
import { StairLandingBothSidesService } from './stair-landing-both-sides.service';
import { BuildTierStepsService } from './build-tier-steps.service';
import { WallBuilderService } from './wall/wall-builder.service';

declare let THREE: any;

@Injectable()
export class SuperstructureBuilderService {
  constructor(
    private straightStairService: StraightStairService,
    private stairLandingLeftService: StairLandingLeftService,
    private stairLandingRightService: StairLandingRightService,
    private stairLandingStraightService: StairLandingStraightService,
    private stairLandingBothSidesService: StairLandingBothSidesService,
    private buildTierStepsService: BuildTierStepsService,
    private wallBuilder: WallBuilderService
  ) {}

  buildSuperstructuresForTier(floor): Promise<any> {
    let points = floor.userData.points,
      height = floor.getWorldPosition(new THREE.Vector3()).y,
      edges = floor.userData.edges;

    const result = [];
    let promise;

    for (let i = 0; i < points.length; i++) {
      if (points[i].superstructureType) {
        switch (points[i].superstructureType) {
          case 'straightStair':
            {
              const config = {
                firstPoint: edges[i].firstPoint,
                secondPoint: edges[i].secondPoint,
                distance: points[i].distance,
                width: points[i].width,
                height: height,
                floorId: floor.id
              };
              promise = this.straightStairService.build(config);
            }
            break;
          case 'stairLandingLeft':
            {
              const config = {
                firstPoint: edges[i].firstPoint,
                secondPoint: edges[i].secondPoint,
                distance: points[i].distance,
                width: points[i].width,
                height: height,
                floorId: floor.id
              };
              promise = this.stairLandingLeftService.build(config);
            }
            break;
          case 'stairLandingRight':
            {
              const config = {
                firstPoint: edges[i].firstPoint,
                secondPoint: edges[i].secondPoint,
                distance: points[i].distance,
                width: points[i].width,
                height: height,
                floorId: floor.id
              };
              promise = this.stairLandingRightService.build(config);
            }
            break;
          case 'stairLandingStraight':
            {
              const config = {
                firstPoint: edges[i].firstPoint,
                secondPoint: edges[i].secondPoint,
                distance: points[i].distance,
                width: points[i].width,
                height: height,
                floorId: floor.id
              };
              promise = this.stairLandingStraightService.build(config);
            }
            break;
          case 'stairLandingBothSides':
            {
              const config = {
                firstPoint: edges[i].firstPoint,
                secondPoint: edges[i].secondPoint,
                distance: points[i].distance,
                width: points[i].width,
                height: height,
                floorId: floor.id
              };
              promise = this.stairLandingBothSidesService.build(config);
            }
            break;
          case 'tier2StepUp':
            {
              if (points[i].parent) {
                const config = {
                  firstPoint: edges[i].firstPoint,
                  secondPoint: edges[i].secondPoint,
                  floorId: floor.id,
                  height: height,
                  distance: points[i].distance,
                  width: points[i].width,
                  parentCustomId: floor.userData.parentCustomId,
                  superstructureType: points[i].superstructureType
                };
                promise = this.buildTierStepsService.build1StepUp(config);
              }
            }
            break;
          case 'tier3StepUp':
            {
              if (points[i].parent) {
                const config = {
                  firstPoint: edges[i].firstPoint,
                  secondPoint: edges[i].secondPoint,
                  floorId: floor.id,
                  height: height,
                  distance: points[i].distance,
                  width: points[i].width,
                  parentCustomId: floor.userData.parentCustomId,
                  superstructureType: points[i].superstructureType
                };
                promise = this.buildTierStepsService.build2StepsUp(config);
              }
            }
            break;
          case 'tier2StepDown':
            {
              if (points[i].parent) {
                const config = {
                  firstPoint: edges[i].firstPoint,
                  secondPoint: edges[i].secondPoint,
                  floorId: floor.id,
                  height: height,
                  distance: points[i].distance,
                  width: points[i].width,
                  parentCustomId: floor.userData.parentCustomId,
                  superstructureType: points[i].superstructureType
                };
                promise = this.buildTierStepsService.build1StepDown(config);
              }
            }
            break;
          case 'tier3StepDown':
            {
              if (points[i].parent) {
                const config = {
                  firstPoint: edges[i].firstPoint,
                  secondPoint: edges[i].secondPoint,
                  floorId: floor.id,
                  height: height,
                  distance: points[i].distance,
                  width: points[i].width,
                  parentCustomId: floor.userData.parentCustomId,
                  superstructureType: points[i].superstructureType
                };
                promise = this.buildTierStepsService.build2StepsDown(config);
              }
            }
            break;
          case 'wall':
            {
              const config = {
                firstPoint: edges[i].firstPoint,
                secondPoint: edges[i].secondPoint,
                distance: points[i].distance,
                width: points[i].width,
                superstructureType: 'wall',
                height: points[i].height,
                material: points[i].material,
                floorId: floor.id,
                windowsDoors: points[i].windowsDoors,
                awnings: points[i].awnings,
                trellis: points[i].trellis,
                previousPoint: points[i > 0 ? i - 1 : points.length - 1]
              };
              const wall = this.wallBuilder.createWall(config);

              if (config.windowsDoors) {
                this.wallBuilder.createWindowsDoors(config.windowsDoors, wall);
              }

              if (config.awnings && config.awnings.items && config.awnings.items.length) {
                this.wallBuilder.createAwnings(config.awnings, wall);
              }

              if (config.trellis && config.trellis.length) {
                this.wallBuilder.createTrellis(config.trellis, wall);
              }

              promise = Promise.resolve(wall);
            }
            break;
        }
        result.push(promise);
      }
    }
    return Promise.all(result);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/superstructure-builder.service.ts